import { IDynamicLinkedServiceTypeMetadata } from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';
import { googleCloudStorageMetadata } from 'app/registries/linked-service/google-cloud-storage-metadata';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { CommonResourceKind as ResourceKind, DataSourceOptionKind } from '@powerquery/mashup-editor-client';
import { cdcDestination } from 'app/registries/consts/metadata-consts';

export const sapDatasphereForGoogleCloudStorageMetadata: IDynamicLinkedServiceTypeMetadata = async (injector) => {
    const metadata = await googleCloudStorageMetadata(injector);
    return {
        ...metadata,
        disabled: !__IS_FABRIC_DPE__,
        type: adfModelTypeMap.sapDatasphereForGoogleCloudStorage.linkedServiceType,
        displayName: stringResources.SapDatasphereForGoogleCloudStorageLinkedService_DisplayText,
        icon: {
            className: 'svg-i-100x100-Sap'
        },
        copySourceTypes: [],
        copySinkTypes: [],
        supportedJobModesAsSource: ['CDC'],
        pqoDataSourceOption: {
            kind: DataSourceOptionKind.Extension,
            resourceKind: 'SAPDatasphereGoogleCloudStorage' as ResourceKind
        },
        supportDataFlowSource: false,
        supportDataFlowSink: false,
        supportCopyJobSource: true,
        supportCopyJobSink: false,
        nativeCDCOnly: true,
        cdc: {
            supportCDC: true,
            supportedCDCDestinations: cdcDestination,
            GA: true
        },
        supportDatasetV2: true,
        linkedServiceNamePrefix: 'SAPGoogleCloudStorage',
        supportFirstClassParameterExperience: false,
        controls: [],
        notSupportCopySink: true,
        notSupportDeleteActivity: true,
        supportGetMetadataActivity: false,
        supportStoredProcedureActivity: false,
        supportScriptActivity: false,
        supportAutoFillCopilotInput: false,
        isKnownInPipelineContext: false
    };
};
